<script lang="ts">
    import { Col, Table } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import Tableheader from "../../../Data/ComponentData/DashboardData/Defaultdata/RecentOrders.json";
    import {RecentOrders} from "../../../utils/Constant/Constant"
    import RecentOrdersTable from "./RecentOrdersTable.svelte";
</script>

<Col xl="12" class="recent-order-sec">
    <Card >
        <div slot="contentbody" class="table-responsive">
            <h5>{RecentOrders}</h5>
            <Table borderless>
                <thead>
                    <tr>
                        {#each Tableheader.tableheader as headerItem}
                            <th>{headerItem.header}</th>
                        {/each}
                    </tr>
                </thead>
                <tbody>
                    <RecentOrdersTable />
                </tbody>
            </Table>
        </div>
    </Card>
</Col>
